/* eslint-disable */
/* tslint:disable */
/* auto-generated vue proxies */
import { defineContainer } from './vue-component-lib/utils';

import type { JSX } from '@ovhcloud/ods-stencil/components/radio-button/custom-elements';

import { defineCustomElement as defineOsdsRadioButton } from '@ovhcloud/ods-stencil/components/radio-button/custom-elements/osds-radio-button.js';


export const OsdsRadioButton = /*@__PURE__*/ defineContainer<JSX.OsdsRadioButton>('osds-radio-button', defineOsdsRadioButton, [
  'checked',
  'checking',
  'color',
  'disabled',
  'hasFocus',
  'interactive',
  'size'
]);

